import { render, staticRenderFns } from "./dlt.vue?vue&type=template&id=6974ce22"
import script from "./dlt.vue?vue&type=script&lang=js"
export * from "./dlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports